import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
   toggled = false;
  _hasBackgroundImage = true;
  menus = [
    {
      title: 'Data Integration Toolkit Home',
      active: false,
      type: 'simple',
      path: '/data-integration-toolkit-home'
    },
    {
      title: 'Solutions',
      active: false,
      type: 'dropdown',
      path: '/unlocked/solutions-home',
      submenus: [
        {
          title: 'Data Solutions',
            path: '/unlocked/data-solutions/data-solutions',
        },
        {
          title: 'Take the Next Step',
          path: '/unlocked/next-step'
        }
      ]
    },
    {
      title: 'Technology',
      path:"/unlocked/technology",
      active: false,
      type: 'dropdown',
      submenus: [
        {
          title: 'Data Links',
          path: '/locked/data-links',
        },
        {
          title: 'Implement',
          path: '/locked/implement',
          type:'dropdown',
          subsubmenus:[
            {
             title:'Products',
             path: '/locked/products/products'
            },
            {
              title:'New Products',
              path: '/locked/new-products'
             },
             {
              title:'Modules',
              path: '/locked/modules'
             },
             {
              title:'Alliances',
              path: '/locked/alliances'
             },
          ]
        },
        {
          title: 'Toolkit Downloads',
          path: '/locked/toolkit-downloads/toolkit-downloads',
          type:'dropdown',
          subsubmenus:[
            {
             title:'WSDL Product Data Sheet',
             path: '/locked/wsdl-product-data-sheet'
            },
             {
              title:'XML Product Data Sheet',
              path: '/locked/xml-product-data-sheet'
             },
             {
              title:'Java Product Data Sheet',
              path: '/locked/java-product-data-sheet'
             },
             {
              title:'COM Product Data Sheet',
              path: '/locked/com-product-data-sheet'
             },
          ]
        },
        {
          title: 'Test Drive',
          path: '/locked/test-drive',
          type:'dropdown',
          subsubmenus:[
            {
             title:'Company Search',
             path: '/locked/company-search'
            },
            {
              title:'Your Archive',
              path: '/locked/your-archive'
             },
          ]
        },
        {
          title: 'Toolkit White Papers',
          path: '/locked/toolkit-white-papers'
        },
        {
          title: "Tech FAQ's",
          path: '/locked/faqs/tech'
        }
      ]
    },
    {
      title: 'Support',
      path:'/unlocked/support',
      active: false,
      type: 'dropdown',
      submenus: [
        {
         title: 'Service Level Definitions',
          path: '/unlocked/service-level-definitions/service-level-definitions'
        },
        {
          title: "FAQ's",
          path: '/locked/faqs/faq'

        },
        {
          title: 'Tips and Techniques',
          path: '/locked/tips-and-techniques'
        }
      ]
    },
   
  ];
  constructor() { }
  toggle() {
    this.toggled = ! this.toggled;
  }
  getSidebarState() {
    return this.toggled;
  }
  setSidebarState(state: boolean) {
    this.toggled = state;
  }
  getMenuList() {
    return this.menus;
  }
  get hasBackgroundImage() {
    return this._hasBackgroundImage;
  }
  set hasBackgroundImage(hasBackgroundImage) {
    this._hasBackgroundImage = hasBackgroundImage;
  }
}
